module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('page-header', {
    attrs: {
      "title": _vm.title
    },
    scopedSlots: _vm._u([{
      key: "headerIcon",
      fn: function() {
        return [_c('img', {
          attrs: {
            "src": "/static/svg/referral.svg",
            "alt": "referral icon"
          }
        })]
      },
      proxy: true
    }, {
      key: "headerContent",
      fn: function() {
        return [_c('div', {
          staticClass: "header-link-container"
        }, [_c('a', {
          staticClass: "button header-link-button",
          attrs: {
            "href": _vm.historyLink
          }
        }, [_vm._v("View History\n        ")]), _vm._v(" "), (_vm.historyLoaded && _vm.referralsCount) ? _c('span', {
          staticClass: "badge"
        }, [_vm._v(_vm._s(_vm.referralsCount))]) : _vm._e()])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('p', {
    style: (_vm.colorText)
  }, [_c('strong', [_vm._v("Two options:")])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v("1. Share My Referral Link")]), _vm._v(" "), _c('p', {
    staticClass: "mt-0"
  }, [_vm._v("\n      Share your page to your friends, family, or social media. Anyone who\n      shops and completes the form will count as your referral.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "shareLink",
      "id": "shareLink",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.shareLink
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    style: (_vm.buttonStyles),
    attrs: {
      "disabled": !_vm.shareLink
    },
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v("\n        Share\n      ")])])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v("2. Add Friends Manually")]), _vm._v(" "), _c('p', {
    staticClass: "mt-0"
  }, [_vm._v("\n      Add your friend now and send them a personalized link to your referral\n      page.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group fx fx-col"
  }, [_c('div', {
    staticClass: "u-mb2 fx fx-col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referral.name),
      expression: "referral.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 3,
        fullName: true
      }),
      expression: "{ required: true, min: 3, fullName: true }"
    }],
    attrs: {
      "type": "text",
      "name": "referralName",
      "id": "referralName",
      "placeholder": "First & Last Name"
    },
    domProps: {
      "value": (_vm.referral.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.referral, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('referralName')) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first("referralName")))]) : _vm._e()]), _vm._v(" "), _c('vue-tel-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.continues",
      value: ({
        required: true,
        phone: true
      }),
      expression: "{ required: true, phone: true }",
      modifiers: {
        "continues": true
      }
    }],
    staticClass: "text-left",
    attrs: {
      "data-vv-name": "Phone",
      "phone": _vm.referral.phone,
      "invalid": _vm.errors.first('Phone'),
      "name": "phone"
    },
    model: {
      value: (_vm.referral.phone),
      callback: function($$v) {
        _vm.$set(_vm.referral, "phone", $$v)
      },
      expression: "referral.phone"
    }
  }), _vm._v(" "), (_vm.errors.first('Phone')) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('Phone')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button submit-button",
    style: (_vm.buttonStyles),
    attrs: {
      "type": "button",
      "disabled": _vm.loading || _vm.errors.any()
    },
    on: {
      "click": _vm.onNext
    }
  }, [_vm._v("\n        Next\n      ")])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "bottom-link",
    attrs: {
      "href": _vm.howItWorksUrl
    }
  }, [_vm._v("How does this work?")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-025d20fc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-025d20fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/referral/referral-main.vue
// module id = 731
// module chunks = 0